import { Injectable } from "@angular/core";
import { BaseApiService, AuthenticationService, EnvironmentConfig } from "../../core/core";
import { HttpClient } from "@angular/common/http";

declare var environment: EnvironmentConfig;

@Injectable({
  providedIn: "root",
})
export class TransportationService extends BaseApiService<any> {
  constructor(httpClient: HttpClient, authenticationService: AuthenticationService) {
    super(httpClient, environment.transportationApiDomain, "/api/transportation/v1/quote", true, authenticationService);
  }

  getShortHaulEstimate(primaryType: string) {
    const shortHaulMappings = {
      Excavator: 400,
      Dozer: 400,
      Loader: 400,
      "Skid Steer": 400,
      "Water Truck": 400,
      "Dump Truck": 400,
      Tractor: 400,
      Scraper: 400,
      Compactor: 400,
      "Crawler Carrier": 400,
      Telehandler: 400,
      "Padding Machine": 400,
      "Motor Grader": 400,
      Pipelayer: 400,
      "Articulated Truck": 400,
      "Fuel/Lube Truck": 400,
    };

    const shortHaulRate = shortHaulMappings[primaryType];
    return shortHaulRate ? shortHaulRate : 400;
  }

  calculateDistance(lon1, lat1, lon2, lat2): number {
    const R = 6371; // Radius of the earth in km
    const dLat = this.toRad(lat2 - lat1); // Javascript functions in radians
    const dLon = this.toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const km = R * c; // Distance in km
    return Math.ceil(km * 0.621371); // distance in miles
  }

  toRad(coordinate) {
    return (coordinate * Math.PI) / 180;
  }
}
